<template>
    <div class="getBook">        
        <top-component></top-component>
        <div class="content_wrap">
            <div class="add_all">
                <span>选书模板</span>
                <Button size="small" type="danger" @click="selectTemp()">选择模板</Button>
                <Button size="small" type="danger" @click="editTemp()">编辑模板</Button>
            </div>
            <div class="getBook-wrap">
                <Form  ref="form" :model="form" label-width="120px" size="mini">
                    <Row>
                        <Col :span="6">
                            <label style="width: 120px;" class="ss_label">出版社：</label>
                            <FormItem  class="ss_select" label-width="0px" >
                                <Select v-model="isForm.isPubname" placeholder="请选择" >
                                    <Option value="0" label="包含"></Option>
                                    <Option value="1" label="不包含"></Option>
                                </Select>
                            </FormItem>
                            <FormItem class="labelwrap ss_input" label-width="0px"  prop="pubname">
                                <Input placeholder="请输入搜索条件" readonly v-model="form.pubname" @click.native="pubpop(form.pubname)"></Input>
                                <i v-if="form.pubname" class="el-icon-circle-close circleclose" @click="clearValue('pubname','','pubid')"></i>
                            </FormItem>
                        </Col>

                        <Col :span="6">
                            <label style="width: 120px;" class="ss_label">中图分类：</label>
                            <FormItem  class="ss_select" label-width="0px">
                                <Select v-model="isForm.isZtf" placeholder="请选择">
                                    <Option value="0" label="包含"></Option>
                                    <Option value="1" label="不包含"></Option>
                                    <Option value="2" label="等于"></Option>
                                </Select>
                            </FormItem>
                            <FormItem class="labelwrap ss_input" label-width="0px" prop="ztf">
                                <Input placeholder="选择中图分类" v-model="form.ztf" :title="form.ztf" readonly @click.native="ztfflWindow"></Input>
                                <i v-if="form.ztf" class="el-icon-circle-close circleclose" @click="clearValue('ztf','classifydata')"></i>
                            </FormItem>
                        </Col>

                        <Col :span="6">   
                            <!-- <label style="width: 120px;" class="ss_label">学科分类：</label> -->
                            <!-- <FormItem  class="ss_select" label-width="0px">
                                <Select v-model="isForm.isXkfl" placeholder="请选择">
                                    <Option value="0" label="包含"></Option>
                                    <Option value="1" label="不包含"></Option>
                                </Select>
                            </FormItem>              -->
                            <FormItem class="labelwrap " label="学科分类:" prop="subjectShow">
                                <Input placeholder="选择学科分类" readonly v-model="form.subjectShow" :title="form.subjectShow" @click.native="styClass" ></Input>
                                <i v-if="form.subjectShow" class="el-icon-circle-close circleclose" @click="clearValue('subjectShow','xuekedata','xkfl')"></i>
                            </FormItem>
                        </Col>

                        <Col :span="6">
                            <FormItem label="码洋：" >
                                <div class="s-input">
                                    <FormItem prop="myfrom" class="no-margin" >
                                        <Input type="text" v-model="form.myfrom" clearable class="midbox"></Input>
                                        <i class="font">元</i>
                                    </FormItem>
                                </div> 
                                <Col class="line" :span="1">-</Col>
                                <div class="s-input">
                                    <FormItem prop="myto" class="no-margin">
                                        <Input type="text" v-model="form.myto" clearable  class="midbox" ></Input>
                                        <i class="font">元</i>
                                    </FormItem>
                                </div>
                            </FormItem>
                        </Col>

                        <Col :span="6">
                            <label style="width: 120px;" class="ss_label">关键词：</label>
                            <FormItem  class="ss_select" label-width="0px">
                                <Select v-model="isForm.isKeyWord" placeholder="请选择">
                                    <Option value="0" label="包含"></Option>
                                    <Option value="1" label="不包含"></Option>
                                    <Option value="2" label="等于"></Option>
                                </Select>
                            </FormItem>  
                            <FormItem class="ss_input" label-width="0px" prop="keyWord">
                                <Input placeholder="多个以 逗号 隔开" v-model="form.keyWord" clearable></Input>
                            </FormItem>
                        </Col>

                        <Col :span="6">
                            <FormItem label="装帧：" prop="zhuangj">
                                <Select v-model="form.zhuangj" placeholder="请选择" class="sel_collection">
                                    <Option label="全部" value=""></Option>
                                    <Option v-for="item in zzArr" :key="item.key" :label="item.value" :value="item.key"></Option>
                                </Select>
                            </FormItem>
                        </Col>

                         <Col :span="6">
                            <FormItem label="尺寸：">
                                <div class="s-input">
                                    <FormItem prop="sizefrom" class="no-margin">
                                        <Input type="text" v-model="form.sizefrom" clearable class="midbox"></Input>
                                        <i class="font">cm</i>
                                    </FormItem>
                                </div>
                                <Col class="line" :span="1">-</Col>
                                <div class="s-input">
                                    <FormItem prop="sizeto" class="no-margin">
                                        <Input type="text" v-model="form.sizeto" clearable class="midbox"></Input>
                                        <i class="font">cm</i>
                                    </FormItem>
                                </div>
                            </FormItem>
                        </Col>

                        <Col :span="6">
                            <FormItem label="页码：">
                                <div class="s-input">
                                    <FormItem  prop="pageFrom" class="no-margin">
                                        <Input type="text" v-model="form.pageFrom" clearable class="midbox"></Input>
                                        <i class="font">页</i>
                                    </FormItem>
                                </div>
                                <Col class="line" :span="1">-</Col>
                                <div class="s-input">
                                    <FormItem prop="pageTo" class="no-margin">
                                        <Input type="text" v-model="form.pageTo" clearable class="midbox"></Input>
                                        <i class="font">页</i>
                                    </FormItem>
                                </div>
                            </FormItem>
                        </Col>

                        <Col :span="6" >
                            <FormItem label="光盘项：" prop="hasCD">
                                 <Radio v-model="form.hasCD" label="-1">全部</Radio>
                                 <Radio v-model="form.hasCD" label="1">光盘</Radio>
                                 <Radio v-model="form.hasCD" label="0">无光盘</Radio>
                                <!-- <CheckboxGroup v-model="form.hasCD">
                                    <Checkbox label="1" vlaue="1" >光盘</Checkbox>
                                    <Checkbox label="0" vlaue="0" >无光盘</Checkbox>
                                </CheckboxGroup> -->
                            </FormItem>
                        </Col>

                        <Col :span="12">
                            <FormItem label="出版时间：">
                                <div class="date-input">
                                    <FormItem  class="no-margin" prop="pubfrom">
                                        <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;"  v-model="form.pubfrom"></DatePicker>
                                    </FormItem>
                                </div>
                                <Col class="line" :span="1">-</Col>
                                <div class="date-input">
                                    <FormItem class="no-margin" prop="pubto">
                                        <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;"  v-model="form.pubto"></DatePicker>
                                    </FormItem>
                                </div>
                            </FormItem>
                        </Col>

                         <Col :span="24" >
                            <FormItem label="读者类型：" prop="useobj">
                            <CheckboxGroup v-model="form.useobj">
                                <Checkbox v-for="(item,i) in objArr" :label="item.value" :vlaue="item.key" :key="i">{{ item.value }}</Checkbox>
                            </CheckboxGroup>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
                <div class="search-btn">
                    <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">检索</Button>
                    <Button @click.native="resetForm" size="mini" class="iconfont icon-reset reset-btn">重置</Button>
                    <Button @click.native="saveSearch" size="mini" class="iconfont icon-reset reset-btn">保存为选书模板</Button>
                </div>
            </div>


            <div v-if="isNonedata" class="nonedata">
                <p>暂无数据！</p>
            </div>

            <div class="opear_d pagefixed cleaxfix" id="pageFixed"  v-if="!isNonedata">
                <Checkbox
                    class="bigCheckbox rd fl"
                    v-model="checkAll"
                    :indeterminate="isIndeterminate"
                    size="small"
                    @change="changeCheckAll"
                >全选</Checkbox>
                <el-pagination
                    class="fr"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="params.current"
                    :page-sizes="[ 40, 80, 120]"
                    :page-size="params.size"
                    layout="prev, sizes, pager, next, jumper, total"
                    :total="total"
                ></el-pagination>
                <el-button v-if="adminState == 0 || adminState == 1" class="plbtn fl" type="warning" plain @click="multiAdd('0')" size="mini">批量加入购物车</el-button>
                <el-button v-if="adminState == 2 || adminState == 3 || adminState == 4 || adminState == 5" class="plbtn fl" type="warning" plain @click="multiAdd('0')" size="mini">批量荐购</el-button>
                <!-- <el-button type="warning" plain @click="multiAdd('1')" size="mini">全部加入购物车</el-button> -->
            </div>

            <div class="LookMenu-container"  id="bookList"  v-if="!isNonedata">
                    <div class="LookMenuSelf" v-for="(item,index) in dataArr" :key="index">
                        <Checkbox class="bigCheckbox" v-model="item.ckb" @change="changeCheck(index)"></Checkbox>
                        <span class="orderedTip" v-if="item.selectNum>0">{{adminState == '0' || adminState == '1' ? '已订购' : '已荐购'}}</span>
                        <div class="imgBacgr" @click="BookDetailClick(item)">
                            <div v-if="item.isImageUrl">
                                <img v-if="item.picpath" :src="item.picpath" @error="errorHandler" class="ImgStyle" alt="">
                            </div>
                            <div v-else>
                                <div class="fmInfo" v-if="!item.isImageUrl">
                                    <h2 class="title">{{item.c200a}}</h2>
                                    <h2 class="author">{{item.c200f}}</h2>
                                    <h2 class="publisher">{{item.c210c}}</h2>
                                    <img :src="item.picpath" @error="errorHandler" class="ImgStyle" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="ImgTitle">{{item.c200a}}</div>
                        <div class="ImgAdress">{{item.c210c}}</div>
                        <div class="ImgAdress">{{item.c210d}}</div>
                        <div class="ImgMoney">￥{{item.m010d}}</div>
                        <div class="textNum">(总订购{{item.allNum}}次)</div>
                        <div class="buttonDiv">
                            <el-button v-if="adminState == 0 || adminState == 1"  type="warning" plain @click="multiAdd(item.pkid)" size="mini" >加入购物车</el-button>
                            <el-button v-else  type="warning" plain @click="multiAdd(item.pkid)" size="mini" >{{ isRmdPost ? '荐购直邮' : '荐购' }}</el-button>
                        </div>
                        
                    </div>
                </div>


            <div class="data_wrap">
                
            </div>
        </div>
        <bottom-component></bottom-component>
    </div>
</template>

<script>
    import { Row, Col, Form, FormItem, Button, Radio, DatePicker, Select, Option, CheckboxGroup, Checkbox,Loading,Input} from 'element-ui'
    import TopComponent from "../Components/TopComponentcopy.vue";
    import BottomComponent from "../Components/BottomComponent.vue";
    import AddInventory from "../../components/AddInventory";
    import Axios from "@/api/diyaxios";
    import { actionsave, addMoreOrder,getdiFangdata,getdetails,shoppingCartnum } from "@/api/pages";
    import { insertPoint } from '@/api/insertPoints'   //添加埋点
    import Cookies from 'js-cookie'
    import popup from "../../common/plugin/dialog/index.js";
    import pubDialog from '../../components/pubDialog';
    import classifyPop from '../../components/ClassifyPop';
    import studyclass from '../../components/studyClassPop';
    import Choose from "./choose";
    import BookTemp from "./bookTemp";
    import EditTemp from "./editTemp";
    import scrollFixed from "../../common/utils/scrollfixed";

    export default {
        data() {
            return {
                form: {
                   
                    pubname:'',
                    pubfrom: null,
                    pubto:null,
                    ztf:'',
                    xkfl:'',//学科
                    subjectShow:'',//显示用
                    myfrom:null,
                    myto: null,
                    pageFrom:null,
                    pageTo:null,
                    sizefrom: null,
                    sizeto:null,
                    useobj:[],
                    hasCD:'-1',
                    keyWord:'',//关键词
                    zhuangj:null,
                },
                source: Cookies.get("source"),
                adminState:Cookies.get("adminState"), 
                isForm:{
                    isPubname:'0',
                    isZtf:'0',
                    isKeyWord:'0',
                },
                params:{//查询参数
                    size: 40,
                    current: 1,
                    // sortRules: '{"cbny": "desc"}'
                },
                objArr:[
                    {key:'本科及以上',value:'本科及以上'},
                    {key:'高职',value:'高职'},
                    {key:'少儿',value:'少儿'},
                    {key:'音像电子',value:'音像电子'},
                    {key:'中职',value:'中职'},
                    {key:'职业教育',value:'职业教育'},
                    {key:'成人教育',value:'成人教育'},
                    {key:'幼儿',value:'幼儿'},
                    {key:'小学',value:'小学'},
                    {key:'初中',value:'初中'},
                    {key:'中小学',value:'中小学'},
                    {key:'高中',value:'高中'},
                    {key:'青少年',value:'青少年'},
                    {key:'通俗读物',value:'通俗读物'},
                    {key:'继续教育',value:'继续教育'}
                ],
                zzArr:[//装帧
                    {key:'平装',value:'平装'},
                    {key:'精装',value:'精装'},
                    {key:'线装',value:'线装'},
                    {key:'活页',value:'活页'},
                    {key:'其它',value:'其它'},
                    {key:'函装',value:'函装'},
                    {key:'盒装',value:'盒装'}
                ],
                pubObjCheck:null,//出版社选中数据
                classifydata:null,//中图 选中
                xuekedata:null,//学科数据
                dataArr:[],//列表
                total: null,
                isIndeterminate:false,//全选状态
                isNonedata: false,//无数据
                checkbookIndex:[],//选中数组
                showLoading: null,
                checkAll: false,//全选
                addivent_pop:null,
                fmBgArr: [require('../../assets/fm_bg/fm01.jpg'), require('../../assets/fm_bg/fm02.jpg'), require('../../assets/fm_bg/fm03.jpg'), require('../../assets/fm_bg/fm04.jpg')]
            }
        },
        components: {
            TopComponent,
            Row, Col, Form, FormItem, Button, DatePicker, Select, Option,
            BottomComponent,Checkbox,CheckboxGroup,Input,Radio
        },
        created() {
            this.scrollFixed("pageFixed", "bookList");
        },
        mounted() {
            let vm = this;

            vm.getDataList(vm.params);
        },
        methods: {
            scrollFixed,
            getSaveParams(type){//获取查询需要的参数 或者 保存模板需要的参数
                let vm = this;
                let obj = Object.assign({}, vm.form);
                delete obj.subjectShow;
                obj.useobj = obj.useobj.join(',');
                //中图法
                if(vm.isForm.isZtf == '1'){//不等于 
                    obj.notztf = obj.ztf;
                    delete obj.ztf;
                }else if(vm.isForm.isZtf == '2'){//等于 
                    obj.eqztf = obj.ztf;
                    delete obj.ztf;
                }
                //出版社
                if(vm.isForm.isPubname == '1'){//不等于 
                    obj.notPubname = obj.pubname;
                    delete obj.pubname;
                }
                //关键词
                if(vm.isForm.isKeyWord == '1'){//不等于 
                    obj.notKeyWord = obj.keyWord;
                    delete obj.keyWord;
                }else if(vm.isForm.isKeyWord == '2'){//等于 
                    obj.eqKeyWord = obj.keyWord;
                    delete obj.keyWord;
                }
                if(type == 'save'){
                    //学科分类
                    if(obj.xkfl){
                        obj.xkfl = vm.xuekedata;
                    }
                    //中图法分类
                    if(vm.isForm.isZtf == '1'){//不等于 
                        obj.notztf = vm.classifydata;
                    }else if(vm.isForm.isZtf == '2'){//等于 
                        obj.eqztf = vm.classifydata;
                    }else{
                        obj.ztf = vm.classifydata;
                    }
                    //classifydata
                    obj.orgGid = Cookies.get('orgGid');
                }else if(type== 'search'){
                    vm.params.current = 1;
                    vm.params.size = 40;
                    obj.size = vm.params.size;
                    obj.current = vm.params.current;
                }
                return obj
            },
            initSearchParams(data){//选择模板
                let vm = this;
                //清空分类选中数据
                vm.classifydata = null;
                vm.xuekedata = null;
                vm.pubObjCheck = null;
                vm.form = {
                    pubfrom: data.pubfrom,
                    pubto:data.pubto,
                    pubname:'',
                    ztf:'',
                    xkfl:'',//学科
                    subjectShow:'',//显示用
                    myfrom:data.myfrom,
                    myto: data.myfrom,
                    pageFrom:data.pageFrom,
                    pageTo:data.pageTo,
                    sizefrom: data.sizefrom,
                    sizeto:data.sizeto,
                    useobj:data.userobjar,
                    hasCD:String(data.hasCD),
                    keyWord:'',//关键词
                    zhuangj:data.zhuangj,
                };

                if(data.xkfl){//学科分类
                    vm.xuekedata = data.xkfl;
                    vm.form.xkfl = data.xkfl.split('|')[0];
                    vm.form.subjectShow = data.xkfl.split('|')[1];
                }
                if(data.ztf){//中图法
                    vm.isForm.isZtf ='0';
                    vm.form.ztf = data.ztf.split('|')[0];;
                    vm.classifydata = data.ztf;
                }else if(data.eqztf){
                    vm.isForm.isZtf = '2';
                    vm.form.ztf = data.eqztf.split('|')[0];;
                    vm.classifydata = data.eqztf;
                }else if(data.notztf){
                    vm.isForm.isZtf = '1';
                    vm.form.ztf = data.notztf.split('|')[0];;
                    vm.classifydata = data.notztf;
                }
                if(data.keyWord){//关键词
                    vm.isForm.isKeyWord ='0';
                    vm.form.keyWord = data.keyWord;
                }else if(data.eqKeyWord){
                    vm.isForm.isKeyWord = '2';
                    vm.form.keyWord = data.eqKeyWord;
                }else if(data.notKeyWord){
                    vm.isForm.isKeyWord = '1';
                    vm.form.keyWord = data.notKeyWord;
                }
                if(data.pubname){//出版社
                    vm.isForm.isPubname ='0';
                    vm.form.pubname = data.pubname;
                }else if(data.notPubname){
                    vm.isForm.isPubname = '1';
                    vm.form.pubname = data.notPubname;
                }
                //设置查询params
                vm.params = vm.getSaveParams('search');
                vm.getDataList(vm.params);
            },
            saveSearch(){
                let vm = this;
                vm.saveSearch_pop = popup(
                    '<Choose @cancel="close" @submit="submit" :objdata="objData"/>',
                    {
                        option: {
                            title: "保存选书模板",
                            width: "500px",
                        },
                        popup: {
                            data() {
                                return {
                                    objData: vm.getSaveParams('save')
                                };
                            },
                            components: {
                                Choose
                            },
                            methods: {
                                submit(data) {
                                    vm.saveSearch_pop.hide();
                                },
                                close(data) {
                                    vm.saveSearch_pop.hide();
                                }
                            }
                        }
                    }
                );
                vm.saveSearch_pop.show();
            },
            selectTemp(){
                let vm = this;
                vm.selectTemp_pop = popup(
                    '<book-temp @cancel="close" @submit="submit" :type="type"/>',
                    {
                        option: {
                            title: "选书模板",
                            width: "980px",
                        },
                        popup: {
                            data() {
                                return {
                                   type:''
                                };
                            },
                            components: {
                                'book-temp':BookTemp
                            },
                            methods: {
                                submit(data) {
                                    vm.initSearchParams(data);
                                    vm.selectTemp_pop.hide();
                                },
                                close(data) {
                                    vm.selectTemp_pop.hide();
                                }
                            }
                        }
                    }
                );
                vm.selectTemp_pop.show();
            },
            editTemp(){
                let vm = this;
                vm.editTemp_pop = popup(
                    '<edit-temp @cancel="close" @submit="submit" :type="type"/>',
                    {
                        option: {
                            title: "选书模板",
                            width: "980px",
                        },
                        popup: {
                            data() {
                                return {
                                   type:''
                                };
                            },
                            components: {
                                'edit-temp':EditTemp
                            },
                            methods: {
                                submit(data) {
                                    vm.editTemp_pop.hide();
                                },
                                close(data) {
                                    vm.editTemp_pop.hide();
                                }
                            }
                        }
                    }
                );
                vm.editTemp_pop.show();
            },
            beforeAddCar(obj){
                return new Promise((resolve, reject)=>{
                    let vm = this;
                    Axios.post('/goods/action/check', { params: JSON.stringify(obj.goodsIdList)},
                        {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }
                    ).then(res => {
                        let datalist = res.data || {};
                        if(datalist.duplicateList && datalist.duplicateList.length > 0){//无重复
                            vm.$confirm("重复采购，是否继续提交？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: "warning"
                            }).then(() => {
                                //全部数组
                                resolve(obj)
                            }).catch(() => {});
                           
                        }else{//有重复
                            resolve(obj)
                        }
                    });
                });
            },
            onSubmit(){
                let vm = this;
                vm.params = vm.getSaveParams('search');
                vm.getDataList(vm.params);
            },
            //重置
            resetForm(){
                let vm = this;
                vm.classifydata = null;
                vm.xuekedata = null;
                vm.pubObjCheck = null;
                vm.form.xkfl = null;
                vm.isForm.isPubname = '0';
                vm.isForm.isZtf = '0';
                vm.isForm.isKeyWord = '0';
                // vm.temp.pubid = null;
                vm.$refs.form.resetFields();
            },
             // 获取数据
            getDataList(params) {
                let vm = this,
                    url = "/bls/action/search";
                vm.showLoading = Loading.service({
                    target: "body",
                    spinner: "el-icon-loading",
                    text: "加载中...",
                    background: "rgba(255, 255, 255, 0.5)"
                });
                this.isNonedata = false;
                Axios.post(url, { params: params },
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                ).then(res => {
                        //清空已勾选
                        vm.checkbookIndex = [];
                        vm.checkAll = false;
                        vm.isIndeterminate = false;
                        let d =  res.data;
                        if (res.status && d.data && d.data.entities.length > 0) {
                            vm.isNonedata = false;
                            vm.dataArr = d.data.entities;
                            vm.total = d.data.total;
                            vm.dataArr.forEach((ele, i) => {
                                vm.$set(vm.dataArr[i], "ckb", false);
                                if(!ele.hasOwnProperty('picpath')||ele.picpath ==null){
                                let isbnStr = ele.cisbn.replace(/-/g,''),
                                bgIndex = isbnStr%3; //随机生成0~3之间的数字
                                // let bgIndex = Math.floor((Math.random()*4)); //随机生成0~3之间的数字
                                vm.$set(vm.dataArr[i], 'isImageUrl', false);
                                vm.$set(vm.dataArr[i], 'picpath', vm.fmBgArr[bgIndex]);
                            }else{
                                vm.$set(vm.dataArr[i], 'isImageUrl', true);
                            }
                            });
                        } else {
                            vm.dataArr = [];
                            vm.isNonedata = true;
                            if(d.code == '500' && d.errorMsg){
                                vm.$message({
                                    message: d.errorMsg,
                                    type: "warning"
                                });
                            }
                        }
                        vm.$nextTick(() => {
                            // 以服务的方式调用的 Loading 需要异步关闭
                            vm.showLoading.close();
                        });
                    }).catch(err => {
                    });
            },
            //全选
            changeCheckAll(flag) {
                let vm = this;
                vm.isIndeterminate = false;
                if (flag) {
                    //清空
                    vm.checkbookIndex = [];
                    vm.dataArr.forEach((ele, i) => {
                        vm.$set(vm.dataArr[i], "ckb", true);
                        vm.checkbookIndex.push(i);
                    });
                    vm.checkAll = true;
                } else {
                    // 取消全选
                    vm.checkbookIndex = [];
                    vm.dataArr.forEach((ele, i) => {
                        vm.$set(vm.dataArr[i], "ckb", false);
                    });
                    vm.checkAll = false;
                }
            },
            changeCheck(index) {
                let vm = this,
                    arr = vm.checkbookIndex;
                if (arr.indexOf(index) > -1) {
                    arr.splice(arr.indexOf(index), 1);
                    vm.$set(vm.dataArr[index], "ckb", false);
                } else {
                    arr.push(index);
                    vm.$set(vm.dataArr[index], "ckb", true);
                }
                if (arr.length == vm.dataArr.length) {
                    vm.checkAll = true;
                    vm.isIndeterminate = false;
                } else if (arr.length > 0 && arr.length < vm.dataArr.length) {
                    vm.checkAll = false;
                    vm.isIndeterminate = true;
                } else if (arr.length == 0) {
                    vm.checkAll = false;
                    vm.isIndeterminate = false;
                }
                vm.checkbookIndex = arr;
            },
            //批量加入购物车
            multiAdd(type) {
                console.log(type,'type');
                let vm = this;
                if (Cookies.get("token")) {
                    if (type == "0") {
                        //批量加入购物车
                        let checkedList = [];
                        if (vm.checkbookIndex.length > 0) {
                            //获取批量勾选的数据
                            for (var i in vm.checkbookIndex) {
                                checkedList.push(
                                    vm.dataArr[vm.checkbookIndex[i]].goodsId
                                );
                            }
                            if(vm.adminState == '0' || vm.adminState == '1'){
                                vm.showAmountPop(checkedList);
                            }else{
                                vm.addCarbyBooks(checkedList);
                            }



                            // vm.showAmountPop(checkedList);
                        } else {
                            vm.$message({
                                message: "请至少勾选中一本书！",
                                type: "warning"
                            });
                        }
                    } else if (type == "1") {
                        // 全部加入购物车
                        let checkedList = [];
                        vm.dataArr.forEach(ele => {
                            checkedList.push(ele.goodsId);
                        });
                        vm.showAmountPop(checkedList);
                    } else {
                        //单个加入购物车
                        let checkedList = [];
                        checkedList.push(type);
                        // vm.showAmountPop(checkedList);
                        var obj = {
                            goodsIdList: checkedList,
                            userId: Cookies.get("UserID"),
                            amount: 1
                        };
                        vm.beforeAddCar(obj).then(function(obj){
                            addMoreOrder(obj).then(response => {
                                if(response.code ==200){
                                    if(vm.adminState == 0 || vm.adminState == 1 ){
                                vm.$message({
                                    message: '加入购物车成功',
                                    type: 'success',
                                    duration:800
                                });
                            }else if (vm.adminState == 2 || vm.adminState == 3 || vm.adminState == 4 || vm.adminState == 5){
                                vm.$message({
                                    message: '荐购成功',
                                    type: 'success'
                                }); 
                            }   
                                vm.getShopCarData()
                                //添加“加入购物车”埋点
                                let doId = +localStorage.getItem('doId') + 1;
                                localStorage.setItem('doId', doId);
                                insertPoint(obj, 'click', 'shop', doId); //添加埋点
                                vm.getDataList(vm.params);
                                // vm.DiFangData(vm.params);  
                                }
                            });
                        })
                    }
                } else {
                    localStorage.setItem('pageUrl', `/${window.location.hash}`);
                    vm.$router.push({
                        name: "Login"
                        // params: { type: "LookPublishingPagesType", params:vm.$route.params }
                    });
                }
            },
            //批量或单个加入荐购
            addCarbyBooks(list){
                let vm = this, 
                    obj = {
                        goodsIdList: list,
                        userId: Cookies.get("UserID"),
                        source:Cookies.get("source"),
                        amount: 1
                    };
                vm.beforeAddCar(obj).then(function(obj){
                    addMoreOrder(obj).then(res => {
                        if(res.status){                                    
                            if(vm.adminState == 0 || vm.adminState == 1 ){
                                vm.$message({
                                    message: '加入购物车成功',
                                    type: 'success',
                                    duration:800
                                });
                            }else if (vm.adminState == 2 || vm.adminState == 3 || vm.adminState == 4 || vm.adminState == 5){
                                vm.$message({
                                    message: '荐购成功',
                                    type: 'success'
                                }); 
                            }   
                            vm.getShopCarData()
                            //添加“加入购物车”埋点
                            let doId = +localStorage.getItem('doId') + 1;
                            localStorage.setItem('doId', doId);
                            insertPoint(obj, 'click', 'shop', doId); //添加埋点    
                            vm.getDataList(vm.params);                        
                            // vm.DiFangData(vm.params);
                        }else if(res.code == '10000'){
                            vm.$confirm('您还没有收货地址，需要设置收货地址才可以荐购，需要设置吗？', '提示', {
                                confirmButtonText: '前往设置',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                // const router = this.$router.resolve({
                                //     path: '/addressmanagement',
                                // })
                                // window.open(router.href)
                                vm.goChangeAddress();
                            }).catch(() => {
    
                            });
                        }
                    }).catch(err => {
                        vm.$message({
                            message: err.res.errorMsg,
                            type: 'error',
                            duration: 800
                        });
                    });
    
                })
            },
            // 展示购物车数据
        async getShopCarData() {
            let data = {
                userId: Cookies.get("UserID"),
                source:Cookies.get("source")
            };
            let res = await shoppingCartnum(data)
            if(res.code == '200'){
                this.$store.state.DataStorage.GoodLengthData = res.data;
            }
        },
            //选择复本数弹窗
            showAmountPop(goodsIds) {
                let vm = this;
                vm.addivent_pop = popup(
                    '<add-inventory @cancel="close" @submit="submit" :objdata="objData" :intype="intype"/>',
                    {
                        option: {
                            title: "设置采购数量",
                            width: "433px",
                            customClass: "pop-add-list"
                        },
                        popup: {
                            data() {
                                return {
                                    objData: {
                                        gids: goodsIds
                                    },
                                    intype:'bookTemp'
                                };
                            },
                            components: {
                                AddInventory
                            },
                            methods: {
                                submit(data) {
                                    vm.getShopCarData()
                                    vm.getDataList(vm.params);
                                    vm.addivent_pop.hide();
                                },
                                close(data) {
                                    vm.addivent_pop.hide();
                                }
                            }
                        }
                    }
                );
                vm.addivent_pop.show();
            },
             //清除
            clearValue(prop,val,data) {
                let vm = this;
                vm.form[prop] = null;
                if(val) vm[val] = null;
                if(data) vm.form[data] = null;
            },
            //学科分类
            styClass() {
                let vm = this;
                vm.sty_clsss = popup('<studyclass @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '学科分类',
                        width: '630px'
                    },
                    popup: {
                        data(){
                            return {
                                msg: vm.xuekedata
                            }
                        },
                        components: {
                            studyclass
                        },
                        methods: {
                            submit(data){
                                vm.xuekedata = data;
                                let arr = data.split('|');
                                vm.form.subjectShow = arr[1];
                                vm.form.xkfl = arr[0];
                                vm.sty_clsss.hide();
                            },
                            close(data){
                                vm.sty_clsss.hide();
                            }
                        }
                    }
                });
                vm.sty_clsss.show();
            },
             //中图法
            ztfflWindow() {
                let vm = this;
                vm.m_modal = popup('<classify-pop @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '中图法分类',
                        width: '800px'
                    },
                    popup: {
                        data(){
                            return {
                                msg: vm.classifydata
                            }
                        },
                        components: {
                            classifyPop
                        },
                        methods: {
                            submit(data){
                                let str = String(data.msgCode);
                                vm.$set(vm.form,'ztf',str);
                                vm.classifydata = data.dataStr;
                                vm.m_modal.hide();
                            },
                            close(data){
                                vm.m_modal.hide();
                            }
                        }
                    }
                });
                vm.m_modal.show();
            },
             //出版社
            pubpop() {
                let vm = this;
                vm.pub_pop = popup('<pub-dialog @close="close" :msg="msg" @ok="submit" />',{
                    option:{
                        title:'出版社选择',
                        width:'630px'
                    },
                    popup:{
                        data(){
                            return{
                                msg: vm.pubObjCheck
                            }
                        },
                        components:{
                            pubDialog
                        },
                        methods:{
                            submit(data){
                                vm.form.pubname = data.pubname;
                                // vm.form.pubid = data.pubid;
                                vm.pubObjCheck =  data.choosedData;
                                vm.pub_pop.hide();
                            },
                            close(data){
                                vm.pub_pop.hide();
                            }
                        }
                    }
                })
                vm.pub_pop.show();
            },

            // 点击跳转详情页
            BookDetailClick(item) {
                const { href } = this.$router.resolve({
                    name: "BookDetail",
                    params: { goodsId: item.pkid }
                });
                window.open(href, "_blank");
            },
            // 分页
            handleSizeChange(val) {
                this.params.size = val;
                this.getDataList(this.params);
            },
            handleCurrentChange(val) {
                this.params.current = val;
                this.getDataList(this.params);
                // Cookies.set('PublishingPagesTypecurrentPage', val)
            },
            errorHandler(event) {
                event.target.classList.add('error')
            },
            // 问题反馈
            problemReport(){
               
            }
        }
    }
</script>

<style lang='scss'>
@import "../../style/booklist";
.getBook{
    width: 100%;
    background-color: #f9f9f9;
    .content_wrap{
        padding: 10px 20px;
        .add_all{
            >span{
                color: #606266;
                font-size: 16px;
            }
            padding: 15px;
            background-color: #fff;
            
        }
        .opear_d{
            height: 32px;
            padding: 8px 0px;
            .rd{
                margin-top: 5px;
                margin-left: 10px;
            }
            .rdj{
                margin-top: 2px;
                margin-left: 20px;
            }
        }
    }
    .getBook-wrap{
        margin-top: 10px;
        padding: 15px;
        width: calc(100% - 30px);
        background-color: #fff;
        .el-radio__label{padding-left: 2px;}
        .el-radio{ margin-right: 2px;}

        .ss_label{
            padding-right: 5px;
             font-size: 12px;
            text-align: right;
            vertical-align: middle;
            float: left;
            line-height: 28px;
        }
        .ss_select{
            float:left;
            width: 70px;
            .el-input{
                width: 70px;
            }
            .el-input__inner{
                padding:0px 8px;
                width: 70px;
            }
        }
        .ss_input{
            float:left;
            width: 80px;
            .el-input{
                width: 116px;
            }
            .el-input__inner{
                padding:0px 8px;
                width: 116px;
            }
            .circleclose{
                margin-right: -60px;
            }
        }
        .search-btn{
            text-align: center;
            padding-top:15px;
        }

        .no-margin{
            margin:0 !important;
            // width:72px;
        }
        .el-input{
            width: 192px;
        }
        .el-input__inner{
            padding:0px 8px;
            width: 192px;
        }   
        .s-input{   
            float: left;
            width:75px;
            .el-form-item__content{
                .midbox{
                    width: 52px;
                }
            }      
            .el-input__inner{
                padding:0px 8px;
                width: 52px;
            }
        }
        .date-input{
            float: left;
            width:130px;
            .el-input__inner{
                padding:0px 8px;
                width: 128px;
            }
        }
        .el-input--prefix .el-input__inner{
            padding-left:25px;
        }
        .line{
            text-align: center;
        }
        .s-input{
            .el-input{
                width:70%;
            }
            i{
                font-style: normal;
            }
        }
        .el-form-item__label{
            padding-right:5px;
            font-size: 12px;
        }
        .search-btn{
            text-align: center;
            padding-top:15px;
        }       
        
        //表单清除
        .labelwrap{
            position: relative;
            .circleclose{display: none}
            .el-form-item__content:hover .circleclose{
                position: absolute;
                cursor: pointer;
                top: 3px;
                right: 0px;
                height: 24px;
                line-height: 24px;
                width: 24px;
                text-align: center;
                color: #bcc0c5;
                display: block;
            }
        }

       
    }

}

 /* 分类弹框样式 */
.cont-sty{//学科、大众
    .el-col .treebox{
        width: 209px;
        height: 323px;
        padding: 15px 0 0 15px;
        padding-right:0px;
        margin:28px 0 0 38px;
        background-color: #fff;
        border-radius: 4px;
        border: solid 1px #c9d7e8;
        .search-sty{
            .el-input__inner{
                width: 200px;
                height: 32px;
                padding-left: 28px;
                background-color: #fff;
                border-radius: 16px;
                height: 28px;
                line-height: 28px;
                border: solid 1px #b6d2e6;
            }
            .el-icon-search{
                line-height: 32px;
            }
        }
        .lefttree{
            height: 291px;
            overflow: auto;
            list-style: none;
            .check-box{
                cursor: pointer;
                margin-top:10px;
            }
        }
        .tit{
            font-weight: bold;
            font-size: 13px;
        }
        .right-tree{
            width: 209px;
            height: 301px;
            overflow: auto;
            list-style: none;
            padding: 0px;
            >li{
                cursor:pointer;
                margin-top:10px;
                span{
                    display: inline-block;
                    width: 170px;
                    font-size: 12px;
                }
                i{
                    font-size: 17px;
                    color:#bbc8d4;
                }
                &:hover i{
                    color:#1c7bd3;
                }
            }
            >li:hover{
                color: #1c7bd3;
            }
        }
        .noData{
            text-align: center;
            font-size: 12px;
            img{
                height: 90px;
                width: 70px;
                margin: 30px auto 15px;
                display: block;
            }
            .p{
                margin: 4px;
            }
        }
        
    }    
}
.clearbtn {
    float: right;
    margin-right: 18px;
    width: 47px;
    height: 22px;
    line-height: 22px;
    background-color: #ffeaea;
    border-radius: 2px;
    border: 1px solid #f2c3c3;
    color: #ce4747;
}
.btnbase{
    border: 0px;
    // border-radius: 50px;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    // padding:0 24px;
    display:inline-block;
    height: 33px;
    line-height:33px;
    margin: 8px 12px;
    width: 70px;
    background-color: #deefff;
    border-radius: 4px;
}
.btn_box{
    //按钮样式
    text-align: center;
    margin-top:15px;
    .btn_sure{
        @extend .btnbase ;
        color: #fff;
        background-color:#2c88f4;
    }
    .btn_canle{
        @extend .btnbase ;
        color:  #2c88f4;
        background-color:  #deefff;
    }
    .btn_green{
        @extend .btnbase ;
        color: #fff;
        background-color:#67c23a;
    }
}

</style>


// WEBPACK FOOTER //
// src/views/getBook/index.vue